import * as classnames from 'classnames/bind';
import * as React from 'react';

const styles = require('./Card.module.less');
const cx = classnames.bind(styles) as any;

interface Props
{
    className?:string;
    isEnlargeOnHover?:boolean;
}

class State
{
    animationClassNames:string = '';
}

export class Card extends React.Component<Props, State>
{
    constructor(props:Props)
    {
        super(props);
        this.state = new State();
    }

    private _onMouseOver(e:any)
    {
        this.setState({animationClassNames:'enlargeCard'})
    }

    private _onMouseOut(e:any)
    {
        this.setState({animationClassNames:'shrinkCard'})
    }

    render()
	{
	    const {className, isEnlargeOnHover} = this.props;
	    const {animationClassNames} = this.state;

		return 	(
			<div className={cx(className, 'card', {'enlargeOnHover':isEnlargeOnHover}, animationClassNames)}
                 onMouseOver={this._onMouseOver.bind(this)}
                 onMouseOut={this._onMouseOut.bind(this)}>
                {this.props.children}
			</div>);
	}
}

